<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Regiões">
      <router-link
        class="float-right text-white btn btn-success"
        :to="{ name: 'admin-region-new' }"
      >
        Nova Região
      </router-link>
    </page-header>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-flex justify-content-around custom-header"
          >
            <div
              class="col-md-3 col-12 d-flex justify-content-center justify-content-md-start align-items-center"
            >
              <h6 class="m-md-0 m-2">Regiões ativas</h6>
            </div>
            <div class="col-md-9 col-12 p-0">
              <form class="main w-100">
                <d-form-row>
                  <d-col
                    sm="12"
                    lg="4"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <select-state
                      :model.sync="pagination.state"
                      :onChange="onChangeStates"
                    />
                  </d-col>
                  <d-col
                    sm="12"
                    lg="8"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <input-search
                      :model.sync="pagination.search"
                      id="input_region_list_search"
                    />
                  </d-col>
                </d-form-row>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <region-table :regions="regionTeams.list" />
            </div>
            <pagination
              :total-items="regionTeams.total_items"
              :pagination.sync="pagination"
              eventName="update:pagination_region_list"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Pagination from '_shared/Pagination.vue';
import SelectState from '_shared/SelectState.vue';
import InputSearch from '_shared/InputSearch.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import RegionTable from '../components/RegionListTable.vue';

export default {
  name: 'region-team-list',
  components: {
    PageHeader,
    RegionTable,
    SelectState,
    Pagination,
    InputSearch,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        search: '',
        state: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    regionTeams() {
      const { regionList } = this.$store.state.region;
      if (regionList && regionList.list.length) {
        return regionList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['setToggle', 'checkAdmin', 'getRegionList']),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getRegionList(this.pagination).then(() => {
        this.setToggle({ type: 'progress', bool: false });
      });
    },
    onChangeStates() {
      this.pagination.skip = 0;
      this.pagination.page = 1;
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination_region_list', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(this.pagination);
      if (pagination && paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
  },
  destroyed() {
    Events.$off('update:pagination_region_list');
  },
};
</script>
